import ApiService, {ApiPatch, ApiPost} from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import oitsActionCreators from '../../oits/action-creators/index';
import trainingPhasesCommitTypes from '../commit-types';
import trainingPhasesActionsCreators from './training-phases';
import notificationsActionsCreator from '../../notifications/action-creators';
import trainingPhasesReportAttachmentsActions from './training-phase-report-attachments';
import trainingPhasesReportNotesActions from './training-phase-report-notes';
import reportsActionCreators from "../../reports/action-creators";

const trainingPhasesReportsActions = {
  acknowledgeReport({responsesAck, ...formData}) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('acknowledgeReport'));
      const postData = { ...formData };
      delete postData.guid;
      const data2 = await ApiPatch(`/api/v1/reports/${formData.guid}/acknowledge`, {responsesAck})
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        })
        .then(() => ApiService.post(`/api/v1/reports/${formData.guid}/acknowledge`, postData))

      dispatch(trainingPhasesActionsCreators.setIsLoading('acknowledgeReport'));

      if (data2) {
        dispatch(this.acknowledgeReportSuccess(data2.data));
      }
      return Promise.resolve();
    };
  },
  acknowledgeReportUpdate({responsesAck, ...formData}) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('acknowledgeReport'));
      const postData = { ...formData };
      delete postData.guid;
      const data2 = await ApiPatch(`/api/v1/reports/${formData.guid}/acknowledge`, {responsesAck})
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        })

      dispatch(this.replaceReport(data2));
      dispatch(reportsActionCreators.replaceReport(data2))
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved successfully!'));
      return Promise.resolve();
    };
  },
  acknowledgeReportSuccess(acknowledged) {
    return (dispatch) => {
      dispatch(this.replaceReport(acknowledged.data));
      dispatch(reportsActionCreators.replaceReport(acknowledged.data))
      dispatch(this.closeViewReport());
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report acknowledged'));
      if (acknowledged.data.type === 'cont') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(acknowledged.data.attributes.trainingPhaseGuid));
      }
    };
  },
  approveReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      const postData = { ...formData };
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/approve-one`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      if (data) {
        dispatch(this.approveReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  rejectReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      const postData = {...formData};
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/reject`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      if (data) {
        dispatch(this.rejectReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  recallReport(reportId) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      const data = await ApiService.post(`/api/v1/reports/${reportId}/recall`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      if (data) {
        dispatch(this.recallReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  skipAck({guid: reportId}) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      const data = await ApiService.post(`/api/v1/reports/${reportId}/skip-acknowledge`, {
        date: new Date
      })
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('approveReport'));
      if (data) {
        dispatch(this.skipStepReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  approveReportSuccess(approved) {
    return (dispatch) => {
      dispatch(this.replaceReport(approved.data));
      dispatch(reportsActionCreators.replaceReport(approved.data));
      dispatch(this.closeViewReport());
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report approved'));
      if (approved.data.type === 'rrt') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(approved.data.attributes.trainingPhaseGuid));
      }
    };
  },
  rejectReportSuccess(approved) {
    return (dispatch) => {
      dispatch(this.replaceReport(approved.data));
      dispatch(reportsActionCreators.replaceReport(approved.data));
      dispatch(this.closeViewReport());
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report rejected'));
      if (approved.data.type === 'rrt') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(approved.data.attributes.trainingPhaseGuid));
      }
    };
  },
  recallReportSuccess(approved) {
    return (dispatch) => {
      dispatch(this.replaceReport(approved.data));
      dispatch(reportsActionCreators.replaceReport(approved.data));
      dispatch(this.closeViewReport());
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report recalled'));
      if (approved.data.type === 'rrt') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(approved.data.attributes.trainingPhaseGuid));
      }
    };
  },
  skipStepReportSuccess(approved) {
    return (dispatch) => {
      dispatch(this.replaceReport(approved.data));
      dispatch(reportsActionCreators.replaceReport(approved.data));
      dispatch(this.closeViewReport());
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Signoff skipped'));
      if (approved.data.type === 'rrt') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(approved.data.attributes.trainingPhaseGuid));
      }
    };
  },
  closeAddReport() {
    return (dispatch) => {
      dispatch(this.setIsAddingReport(false));
    };
  },
  closeEditReport() {
    return (dispatch) => {
      dispatch(this.setIsEditingReportModal(false));
      setTimeout(() => dispatch(this.setIsEditingReport(null)), 310);
    };
  },
  closeViewReport() {
    return (dispatch) => {
      dispatch(this.setIsViewingReportModalOpened(false));
      setTimeout(() => dispatch(this.setIsViewingReport(null)), 310);
    };
  },
  createReport(formData) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('createReport'));
      const data = await ApiService.post('/api/v1/reports', formData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(this.setIsLoading('createReport'));
      if (data) {
        dispatch(this.createReportSuccess(data));
      }
      return Promise.resolve(data.data.guid);
    };
  },
  createReportSuccess(created) {
    return (dispatch) => {
      dispatch(this.pushReport(created.data));
      dispatch(this.setIsAddingObservationReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report created'));
    };
  },
  deleteDraftReport(reportGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteDraftReport'));
      const data = await ApiService.delete(`/api/v1/reports/${reportGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('deleteDraftReport'));
      if (data) {
        dispatch(this.deleteDraftReportSuccess(data));
      }
      return Promise.resolve();
    };
  },
  deleteDraftReportSuccess(deleted) {
    return (dispatch) => {
      dispatch(this.removeReport(deleted.data));
      dispatch(reportsActionCreators.removeReport(deleted.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Draft deleted'));
    };
  },
  editReport(reportGuid) {
    return (dispatch) => {
      console.log('REPORT GUID', reportGuid)
      dispatch(this.setIsEditingReport(reportGuid));
      dispatch(this.setIsEditingReportModal(true));
    };
  },
  rewriteReport(reportGuid) {
    return (dispatch) => {
      ApiPost(`/api/v1/reports/${reportGuid}/rewrite`)
        .then(report => {
          dispatch(this.replaceReport(report));
          dispatch(reportsActionCreators.replaceReport(report));
          dispatch(this.editReport(reportGuid));
        })
    }
  },
  fetchReportsForTrainingPhase(phaseGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('fetchReportsForTrainingPhase'));
      const data = await ApiService.get(`/api/v1/training-phases/${phaseGuid}/reports`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('fetchReportsForTrainingPhase'));
      if (data) {
        dispatch(this.fetchReportsForTrainingPhaseSuccess(data, phaseGuid));
      }
      return Promise.resolve();
    };
  },
  fetchReportsForTrainingPhaseSuccess(reportsResponse, phaseGuid) {
    return (dispatch) => {
      dispatch(this.setTrainingPhasesReports(reportsResponse.data, phaseGuid));
    };
  },
  loadReportEdit(reportGuid) {
    return (dispatch) => {
      dispatch(trainingPhasesReportAttachmentsActions.fetchAttachmentsForReport(reportGuid));
      dispatch(trainingPhasesReportNotesActions.fetchNotesForReport(reportGuid));
    };
  },
  pushReport(report) {
    return {
      report,
      type: trainingPhasesCommitTypes.PUSH_TRAINING_PHASE_REPORT,
    };
  },
  pushReports(reports) {
    return {
      reports,
      type: trainingPhasesCommitTypes.PUSH_TRAINING_PHASE_REPORTS,
    };
  },
  replaceReports(reports) {
    return {
      reports,
      type: trainingPhasesCommitTypes.REPLACE_TRAINING_PHASE_REPORTS,
    };
  },
  removeReport(deleted) {
    return {
      reportGuid: deleted.guid,
      type: trainingPhasesCommitTypes.REMOVE_TRAINING_PHASE_REPORT,
    };
  },
  replaceReport(report) {
    return {
      report,
      type: trainingPhasesCommitTypes.REPLACE_TRAINING_PHASE_REPORT,
    };
  },
  reviewReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      const postData = { ...formData };
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/approve-two`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      if (data) {
        dispatch(this.reviewReportSuccess(data));
      }
      return Promise.resolve();
    };
  },

  approveThreeReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      const postData = {...formData};
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/approve-three`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      if (data) {
        dispatch(this.reviewReportSuccess(data));
      }
      return Promise.resolve();
    };
  },

  approveFourReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      const postData = {...formData};
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/approve-four`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      if (data) {
        dispatch(this.reviewReportSuccess(data));
      }
      return Promise.resolve();
    };
  },

  approveFiveReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      const postData = {...formData};
      delete postData.guid;
      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/approve-five`, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('reviewReport'));
      if (data) {
        dispatch(this.reviewReportSuccess(data));
      }
      return Promise.resolve();
    };
  },

  reviewReportSuccess(reviewed) {
    return (dispatch) => {
      dispatch(this.replaceReport(reviewed.data));
      dispatch(this.closeViewReport());
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(reportsActionCreators.replaceReport(reviewed.data));
      dispatch(reportsActionCreators.setIsViewingReport(null));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Report approved'));

      if (reviewed.data.type === 'rrt') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(reviewed.data.attributes.trainingPhaseGuid));
      }
    };
  },
  setIsAddingObservationReport(isAddingObservationReport) {
    return {
      isAddingObservationReport,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_ADDING_OBSERVATION_REPORT,
    };
  },
  setIsEditingReport(isEditingReport) {
    return {
      isEditingReport,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_EDITING_REPORT,
    };
  },
  setIsEditingReportModal(modalOpened) {
    return {
      modalOpened,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_EDITING_REPORT_MODAL_OPENED,
    };
  },
  setIsViewingReport(isViewingReport) {
    return {
      isViewingReport,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_VIEWING_REPORT,
    };
  },
  setIsViewingReportModalOpened(modalOpened) {
    return {
      modalOpened,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_IS_VIEWING_REPORT_MODAL_OPENED,
    };
  },
  setTrainingPhasesReports(reports, phaseGuid) {
    return {
      reports,
      phaseGuid,
      type: trainingPhasesCommitTypes.SET_TRAINING_PHASES_REPORTS,
    };
  },
  updateReportResponses(formData, isAutoSave) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('updateReport'));
      const patchData = {
        data: { ...formData },
        patched: 'responses',
      };

      // Remove redundant
      delete patchData.data.guid;
      const data = await ApiService.patch(`/api/v1/reports/${formData.guid}`, patchData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('updateReport'));
      if (data) {
        dispatch(this.updateReportResponsesSuccess(data, isAutoSave));
      }
      return Promise.resolve();
    };
  },
  updateReport(formData) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('updateReport'));
      const patchData = {
        training_phase_id: formData.phase,
        datetime: formData.datetime
      };

      const data = await ApiService.post(`/api/v1/reports/${formData.guid}/update`, patchData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(trainingPhasesActionsCreators.setIsLoading('updateReport'));
      if (data) {
        dispatch(this.updateReportResponsesSuccess(data, true));
      }
      return Promise.resolve();
    };
  },
  updateReportResponsesSuccess(updated, isAutoSave) {
    return (dispatch) => {
      // Handles two cases, so cleanup for both
      if(!isAutoSave) {
        dispatch(this.setIsAddingScheduledReport(false));
        dispatch(this.setIsEditingReportModal(false));
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Report updated'));
      } else {
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved!'));
      }


      setTimeout(
        () => {
          dispatch(this.replaceReport(updated.data));
          dispatch(reportsActionCreators.replaceReport(updated.data));
          if(!isAutoSave) {
            dispatch(this.setIsEditingReport(null));
          }
        },
        310,
      );

      if (updated.data.attributes.status === 'submitted') {
        // Update OIT Progress detail view
        dispatch(oitsActionCreators.fetchTrainingPhase(updated.data.attributes.trainingPhaseGuid));
      }
    };
  },
  viewReport(reportGuid) {
    return (dispatch) => {
      dispatch(this.setIsViewingReport(reportGuid));
      dispatch(this.setIsViewingReportModalOpened(true));
    };
  },
};

export default trainingPhasesReportsActions;
